<template>
  <!-- <SearchNavigator :menuData="menuData"/> -->
  <v-layout>
    <v-navigation-drawer
      id="side-menu"
      v-model="drawer"
      location="left"
      fixed
      :key="navDrawerPinned"
      mobile-breakpoint="0"
      :width="rail ? 64 : 230"
      class="side-menu"
    >
      <!-- Collapse toggle -->
      <div class="toggle-fab" :style="{ left: rail ? '50px' : '216px' }" @click.stop="stopRail()">
        <v-icon size="12" :class="{ 'rotate-icon': rail }">mdi-chevron-left</v-icon>
      </div>

      <!-- Brand strip -->
      <div class="brand-strip" :class="{ 'brand-strip--collapsed': rail }">
        <!-- <div class="brand-icon"> -->
          <!-- <v-icon size="18" color="#ffffff">mdi-hexagon-multiple</v-icon> -->
           <img src="https://synergy-docs.s3.us-east-1.amazonaws.com/live/public/synergy-clarification-logo.png" alt="" width="50" height="50">
        <!-- </div> -->
        <span v-if="!rail" class="brand-name">Synergy</span>
      </div>

      <div class="scroll-area">
        <!-- Quick Access label -->
        <div class="section-label" v-if="!rail">QUICK ACCESS</div>

        <template v-for="item in mainMenu" :key="item.value">
          <v-tooltip :text="item.title" location="right" :disabled="!rail">
            <template v-slot:activator="{ props }">
              <div
                v-if="!item.hideMenu"
                v-bind="props"
                class="nav-item"
                :class="{ 'nav-item--active': item.active }"
                @click="checkRoute(item)"
              >
                <div class="nav-icon">
                  <v-icon v-if="item.icon" size="17" class="nav-img">{{ item.icon }}</v-icon>
                  <img v-else :src="item.imageUrl" class="nav-img" />
                </div>
                <span v-if="!rail" class="nav-label">{{ item.title }}</span>
                <div v-if="item.active && !rail" class="active-dot" />
              </div>
            </template>
          </v-tooltip>
        </template>

        <!-- Divider -->
        <div class="menu-divider" />

        <!-- Dynamic grouped menu -->
        <template v-for="group in menuData" :key="group.id">
          <div v-if="!rail" class="group-header" @click="group.expand = !group.expand">
            <span class="group-label">{{ group.name }}</span>
            <v-icon size="12" class="group-arrow" :class="{ 'group-arrow--open': group.expand }">
              mdi-chevron-right
            </v-icon>
          </div>
          <div v-else class="rail-group-dot" />

          <template v-for="sub in group.subMenu" :key="sub.id">
            <v-tooltip :text="sub.name" location="right" :disabled="!rail">
              <template v-slot:activator="{ props }">
                <div
                  v-if="group.expand || rail"
                  v-bind="props"
                  class="nav-item nav-item--sub"
                  :class="{ 'nav-item--active': sub.active }"
                  @click="MenuRoute(sub)"
                >
                  <div class="nav-icon">
                    <img :src="sub.icon" class="nav-img" />
                  </div>
                  <span v-if="!rail" class="nav-label">{{ sub.name }}</span>
                </div>
              </template>
            </v-tooltip>
          </template>
        </template>
      </div>
    </v-navigation-drawer>
  </v-layout>
</template>
<script>
import ActivityGroupService from "@/api/service/ActivityGroup/ActivityGroupService";
// import {SearchNavigator} from "@tiburadev/global-search"
import MenuService from "@/api/service/Menu/MenuService";
import RolePermissionService from "@/api/service/RolePermission/RolePermissionService";
//import UserService from '@/api/service/UserService';
import RoleService from "@/api/service/Role/RoleService";
import lodash from "lodash";
export default {
  computed: {
    transformValue() {
      return this.rail ? "rotate(180deg)" : "rotate(0deg)";
    },
    leftMargin() {
      return this.rail ? "55px" : "247px";
    },
  },
  components: {
    // SearchNavigator,
  },
  data: () => ({
    drawer: true,
    users: {},
    activities: [],
    navDrawerPinned: false,
    rail: true,
    menu: [],
    menuOptions: [],
    open: ["Users"],
    menuData: [],
    userData:null,
    mainMenu: [
      {
        title: "Home",
        value: "home",
        route: "/",
        icon: "mdi-home-outline",
        active: false,
        hideMenu: false,
      },
      {
        title: "Process Lead Dashboard",
        value: "processLeadDashboard",
        route: "/processLead",
        imageUrl:
          "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/Board_gray.svg ",
        active: false,
        hideMenu: false,
      },
      {
        title: "Past Due",
        value: "backlog",
        route: "/issueconsolidated?pastdue=true",
        imageUrl:
          "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/Backlog_gray.svg ",
        active: false,
        hideMenu: false,
      },
      {
        title: "Critical",
        value: "critical",
        route: "/issueconsolidated?priority=critical",
        imageUrl:
          "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/triangle-exclaimation-svgrepo-com.svg",
        active: false,
        hideMenu: false,
      },
      {
        title: "Board",
        value: "board",
        route: "/issueconsolidated",
        imageUrl:
          "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/Board_gray.svg ",
        active: false,
        hideMenu: false,
      },
      {
        title: "Custom Board",
        value: "customBoard",
        route: "/dashboardwidgets",
        imageUrl:
          "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/dash.svg ",
        hideMenu: false,
      },
      {
        title: "Team Lead Dashboard",
        value: "teamleaddashboard",
        route: "/productionDashboard",
        imageUrl: "https://synergy-snaps.s3.ap-south-1.amazonaws.com/public/Tl.svg",
        hideMenu: true,
      },
      // {
      //   title: "Escalation Dashboard",
      //   value: "escalationdashboard",
      //   route: "/escalationbaord",
      //   imageUrl: "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/Executive+Management_gray.svg",
      //   hideMenu: false,
      // },
      // {
      //   title: "Request Dashboard",
      //   value: "requestdashboard",
      //   route: "/requestBoard",
      //   imageUrl: "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/daily-activity.svg",
      //   hideMenu: false,
      // },


      // {
      //   title: "Account Live Board",
      //   value: "liveboard",
      //   route: "/liveBoard",
      //   imageUrl:
      //     "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/live.png",
      //   active: false,
      //   hideMenu: false,
      // },
      // {
      //   title: "Employee Live Board",
      //   value: "employeeLiveBoard",
      //   route: "/employeeLiveBoard",
      //   imageUrl:
      //     "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/account-live.png",
      //   active: false,
      //   hideMenu: false,
      // },
      // {
      //   title: "Daily Activity DashBoard",
      //   value: "dailyActivityDashBoard",
      //   route: "/dailyActivityDashBoard",
      //   imageUrl:
      //     "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/daily-activity.svg",
      //   active: false,
      //   hideMenu: false,
      // },
      
      // {
      //   title: "Process Lead Dashboard",
      //   value: "processleaddashboard",
      //   route: "/processLeadDashboard",
      //   imageUrl:
      //     "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/account-live.png",
      //   active: false,
      //   hideMenu: false,
      // },
      {
        title: "Exception Reports",
        value: "exceptionreports",
        route: "/exceptionBoard",
        imageUrl:
        "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/exception.png",
        active: false,
        hideMenu: false,
      },
      {
        title: "Dashboard",
        value: "exceptionreports",
        route: "/dashBoard",
        imageUrl:
        "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/commondashboard.png",
        active: false,
        hideMenu: false,
      },
      {
        title: "QC Dashboard",
        value: "qc",
        // route: "/issueconsolidated?priority=qc",
        route: "/qualitycontrol",
        imageUrl:
        "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/Executive+Management_gray.svg",
        active: false,
        hideMenu: false,
      },
       {
        title: "QC Errors",
        value: "qcexception",
        // route: "/issueconsolidated?priority=qc",
        route: "/qcexception",
        imageUrl:
        "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/shield-bad-svgrepo-com.svg",
        active: false,
        hideMenu: false,
      },
       {
        title: "QC Error Approvals",
        value: "qcexceptionapproval",
        // route: "/issueconsolidated?priority=qc",
        route: "/qcapproval",
        imageUrl:
        "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/shield-good-svgrepo-com.svg",
        active: false,
        hideMenu: false,
      },
      // {
      //   title: "Request Board",
      //   value: "Allrequest",
      //   route: "/requestBoard2",
      //   imageUrl:
      //   "https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/exit.png",
      //   active: false,
      //   hideMenu: false,
      // },
    ],
  }),
  async created() {
    let userDetails = localStorage.getItem("user_details");
    userDetails = userDetails ? JSON.parse(userDetails) : {};
    this.userData = userDetails
    let $menuData = localStorage.getItem('MENU_DATA')
    let $mainMenu = localStorage.getItem('MAIN_MENU')
    if($mainMenu && $menuData){
        this.mainMenu = JSON.parse($mainMenu)
        this.menuData = JSON.parse($menuData)
    }
    else{
      if (
      userDetails.roles &&
      userDetails.roles.role_type &&
      userDetails.roles.role_type <= 6
    ) {
      // Show the "Team Lead Dashboard" menu item
      this.mainMenu[6].hideMenu = false;
      // this.mainMenu[9].hideMenu = false;
    }

    this.mainMenu[1].hideMenu =
      userDetails &&
        userDetails.roles &&
        userDetails.roles.role_type &&
        userDetails.roles.role_type < 7
        ? false
        : true;
    await this.getMyRole();
    await this.getPermissionObjects();
    await this.getMenu();
    await this.getAccessToBiomatric()
    this.changeRoute(window.location.pathname);
    localStorage.setItem('MAIN_MENU',JSON.stringify(this.mainMenu))
    }
    
  },
  methods: {
    async getAccessToBiomatric(){
      let res = await RoleService.getAccessForRule({access_role:'SOM',condition:'above',user_role:this.userData.roles.code})
      if(res && res == true){
        this.mainMenu.push(
          {
            title: "Biometrics",
            value: "biometrics",
            route: "/biometrics",
            imageUrl:
            "https://synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/biometric-technology.png",
            active: false,
            hideMenu: false,
          }
          )
        return 
      }
    },
    stopRail() {
      this.rail = !this.rail;
      this.$store.commit('SET_RAIL_EXPANDED', !this.rail);
      this.$emit("toggle-rail");
    },
    async getMenu() {
      let $menu = [];
      let $menuOptions = await MenuService.findAll({active:1,app_type:'synergy'});
      this.menuOptions = $menuOptions;
      let $groups = $menuOptions.filter((obj) => {
        return obj.parent_id == 0;
      });
      $groups = lodash.orderBy($groups, ["sequence_num"], ["asc"]);
      console.log($groups, "group data");
      $groups.forEach((obj) => {
        let SubMenu = $menuOptions.filter((f) => f.parent_id == obj.id);
        let SubMenuData = [];
        SubMenu.forEach((s) => {
          // console.log(s.name);
          // console.log(this.activities);
          // console.log(this.isOkToShow(s.activities),"hello fatataaa",s);
          if (this.isOkToShow(s.activities)) {
            SubMenuData.push({
              id: s.id,
              code: s.code,
              name: s.name,
              icon: s.icon,
              route: s.route,
            });
          }
        });
        console.log(SubMenuData);
        if (SubMenuData.length > 0) {
          $menu.push({
            id: obj.id,
            code: obj.name,
            name: obj.name,
            icon: obj.icon,
            subMenu: SubMenuData,
          });
        }
      });
      this.menuData = this.menu.concat($menu);
      localStorage.setItem('MENU_DATA',JSON.stringify(this.menuData))
      console.log(this.menuData,"hhhhhhhhhhhhhh333332222")
    },
    isOkToShow($activities) {
      let $allowed = false;
      let activities = $activities ? JSON.parse($activities):[]
      for (let $permission of this.permissions) {
        if (activities && activities.includes($permission.activity_id)) {
          if (
            $permission.actions.indexOf("create") >= 0 ||
            $permission.actions.indexOf("CREATE") >= 0
          ) {
            $allowed = true;
          }
        }
      }
      return $allowed;
    },
    async getPermissionObjects() {
      this.permissions = await RolePermissionService.findAll({
        active: 1,
        role_id: this.getMyRole(),
      });
    },
    getMyRole() {
      let $user = localStorage.getItem("user_details");
      $user = JSON.parse($user);
      return $user.role_id;
    },
    async getmenu2() {
      let $menu = [];
      let res = await ActivityGroupService.getAll();
      let $data = res.filter(
        (v, i, a) => a.findIndex((v2) => v2.module_groups === v.module_groups) === i
      );
      $data.forEach((obj) => {
        let SubMenu = res.filter((f) => f.module_groups == obj.module_groups);
        let SubMenuData = [];
        SubMenu.forEach((s) => {
          SubMenuData.push({
            title: s.menu_group,
            icon: s.group_icon,
            route: s.route,
            active: false,
          });
        });
        $menu.push({
          title: obj.module_groups,
          icon: obj.module_icon,
          expand: false,
          subMenu: SubMenuData,
        });
      });
      this.menuData = this.menu.concat($menu);
    },
    onMouseHover() {
      this.navDrawerPinned = true;
    },
    onMouseLeave() {
      this.navDrawerPinned = false;
    },
    checkRoute(item) {
      if (item.value == "backlog") {
        this.$store.commit("SET_ISSUE_DISPLAY", "list");
        localStorage.setItem("issueDisplay", "list");
      } else if (item.value == "board") {
        this.$store.commit("SET_ISSUE_DISPLAY", "board");
        localStorage.setItem("issueDisplay", "board");
      }
      console.log(item, "item.value");
      if(item.value=='backlog'||item.value=='board'||item.value=='critical'){
        localStorage.setItem('menuBoardName',item.value)
      }
      this.$router.push(item.route);
      this.changeRoute(item.route, "above");
    },
    MenuRoute(item) {
      if (item.route) {
        this.$router.push(`${item.route}`);
        this.changeRoute(item.route, "below");
      } else {
        this.$router.push("/");
      }
    },
    changeRoute(route) {
      let url = route;

      for (let i = 0; i < this.menuData.length; i++) {
        for (let j = 0; j < this.menuData[i].subMenu.length; j++) {
          if (this.menuData[i].subMenu[j].route == url) {
            this.menuData[i].subMenu[j].active = true;
          } else {
            this.menuData[i].subMenu[j].active = false;
          }
        }
        // this.menuData[i].subMenu=[this.menuData[i].subMenu]
      }
      for (let $i = 0; $i < this.mainMenu.length; $i++) {
        if (this.mainMenu[$i].route == url) {
          this.mainMenu[$i].active = true;
        } else {
          this.mainMenu[$i].active = false;
        }
      }
    },
  },
};
</script>

<style scoped>
/* ── Drawer shell ── */
.side-menu {
  background: linear-gradient(160deg, #0f2044 0%, #0d2a5e 30%, #0a3080 60%, #1246a8 100%) !important;
  border-right: 1px solid rgba(99,179,255,0.15) !important;
  box-shadow: 4px 0 28px rgba(0,10,50,0.45), inset -1px 0 0 rgba(99,179,255,0.08) !important;
  transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1) !important;
  z-index: 100 !important;
}

/* ── Toggle FAB ── */
.toggle-fab {
  position: fixed;
  top: 84px;
  z-index: 9999;
  width: 22px;
  height: 22px;
  background: linear-gradient(135deg, #1d6fe8, #38bdf8);
  border: 2px solid rgba(255,255,255,0.85);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 0 0 3px rgba(56,189,248,0.25), 0 4px 14px rgba(29,111,232,0.55);
  transition: left 0.28s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s;
}
.toggle-fab:hover {
  box-shadow: 0 0 0 4px rgba(56,189,248,0.4), 0 6px 20px rgba(29,111,232,0.7);
}
.toggle-fab .v-icon { color: #ffffff !important; transition: transform 0.28s ease; }
.toggle-fab .rotate-icon { transform: rotate(180deg); }

/* ── Brand strip ── */
.brand-strip {
  display: flex;
  align-items: center;
  /* gap: 10px; */
  padding: 12px 16px;
  border-bottom: 1px solid rgba(99,179,255,0.15);
  background: linear-gradient(90deg, rgba(0,0,0,0.25), rgba(18,70,168,0.2));
  min-height: 52px;
}
.brand-strip--collapsed { justify-content: center; padding: 12px 0; }
.brand-name {
  color: #ffffff;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  text-shadow: 0 0 18px rgba(99,179,255,0.5);
}

/* ── Scroll area ── */
.scroll-area {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 52px);
  padding: 8px 0 24px;
  scrollbar-width: thin;
  scrollbar-color: rgba(56,189,248,0.35) transparent;
}
.scroll-area::-webkit-scrollbar { width: 3px; }
.scroll-area::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #1d6fe8, #38bdf8);
  border-radius: 4px;
}

/* ── Section label ── */
.section-label {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 2.2px;
  color: rgba(147,197,253,0.5);
  padding: 12px 18px 4px;
  text-transform: uppercase;
}

/* ── Nav item ── */
.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 2px 8px;
  padding: 9px 12px;
  border-radius: 9px;
  cursor: pointer;
  transition: background 0.18s ease, box-shadow 0.18s ease;
  position: relative;
}
.nav-item:hover {
  background: linear-gradient(90deg, rgba(29,111,232,0.35), rgba(56,189,248,0.12));
  box-shadow: inset 0 0 0 1px rgba(99,179,255,0.15);
}
.nav-item:hover .nav-img { filter: brightness(0) invert(1); opacity: 1; }
.nav-item:hover .nav-label { color: #e0f2fe; }
.nav-item:hover .v-icon { color: #7dd3fc !important; }

/* ── Active state ── */
.nav-item--active {
  background: linear-gradient(90deg, rgba(29,111,232,0.55), rgba(56,189,248,0.18));
  border-left: 3px solid #38bdf8;
  padding-left: 9px;
  box-shadow: inset 0 0 0 1px rgba(56,189,248,0.2), 0 2px 16px rgba(29,111,232,0.3);
}
.nav-item--active .nav-label { color: #ffffff; font-weight: 600; }
.nav-item--active .nav-img { filter: brightness(0) invert(1); opacity: 1; }
.nav-item--active .v-icon { color: #7dd3fc !important; }

/* ── Active dot ── */
.active-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #38bdf8;
  margin-left: auto;
  flex-shrink: 0;
  box-shadow: 0 0 6px #38bdf8, 0 0 14px rgba(56,189,248,0.6);
  animation: dot-pulse 2.4s ease-out infinite;
}
@keyframes dot-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(56,189,248,0.7); }
  70%  { box-shadow: 0 0 0 5px rgba(56,189,248,0); }
  100% { box-shadow: 0 0 0 0 rgba(56,189,248,0); }
}

/* ── Sub-item ── */
.nav-item--sub { margin-left: 12px; padding: 7px 12px; }
.nav-item--sub .nav-label { font-size: 13px; color: rgba(147,197,253,0.6); }

/* ── Icon & image ── */
.nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
}
.nav-img {
  width: 15px;
  height: 15px;
  object-fit: contain;
  filter: brightness(0) invert(1);
  opacity: 0.55;
  transition: opacity 0.18s ease;
}
.nav-label {
  font-size: 13.5px;
  font-weight: 500;
  color: rgba(186,224,255,0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  transition: color 0.18s ease;
}

/* ── Divider ── */
.menu-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(56,189,248,0.25), transparent);
  margin: 8px 14px;
}

/* ── Group header ── */
.group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 18px 3px;
  cursor: pointer;
  user-select: none;
}
.group-label {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 2px;
  color: rgba(147,197,253,0.4);
  text-transform: uppercase;
}
.group-arrow { color: rgba(147,197,253,0.4); transition: transform 0.2s ease; }
.group-arrow--open { transform: rotate(90deg); }

/* ── Rail group dot ── */
.rail-group-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(56,189,248,0.3);
  margin: 8px auto;
  box-shadow: 0 0 4px rgba(56,189,248,0.4);
}

@media (min-width: 2880px) {
  .nav-img { width: 20px; height: 20px; }
  .nav-label { font-size: 14px; }
}
</style>
